<template>
  <PageWrapper>
    <div class="feedback">
      <div
        data-pp-cfpw-widget="3f60cac8-7398-11e7-a604-0288f735e5b9"
        data-env="prod"
        data-static="false"
      />
    </div>
  </PageWrapper>
</template>

<script>
import ScriptLoader from '../helpers/script-loader';
import PageWrapper from '../components/PageWrapper.vue';

export default {
  components: {
    PageWrapper,
  },
  async created() {
    const src = 'https://widget.prodpad.com/customer_feedback_portal_app/portal_widget/sdk.js';
    const feedbackScript = document.head.querySelector(`[src="${src}"]`);
    if (feedbackScript) {
      document.head.removeChild(feedbackScript);
    }
    await ScriptLoader.loadScript(src);
  },
};
</script>

<style>
.feedback input {
  max-width: unset;
}
#pp-cfpw {
  font-family: 'semplicitapro', arial, sans-serif !important;
}
</style>
